import React,{useState} from "react";
import { Container, Accordion } from "react-bootstrap";
import Form from "./components/Form";
import Table from "./components/Table";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import EditForm from "./components/EditForm";
import Navbar from "../../components/Navbar";

const Admin = () => {
    
    const COMPANIES_URL = "/users/moderators";
    const { auth } = useAuth();
    const [data,setData]=useState([]);
    const [show,setShow]=useState(false);
    const [editValues,setEditValues]=useState({
        businessname: "",
        username: "",
        pwd: "",
        email: "",
        phone: "",
        cuit: "",
        pwdValid: "",
      })

    const editUser=(values)=>{
        setEditValues(values)
        setShow(true)
    }
    
    
    const getUsers = async () => {
        try {
            const response = await axios.get(
                COMPANIES_URL,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: 'Bearer '+auth?.accessToken,
                  },
                }
              );
              // TODO: remove console.logs before deployment
              setData(response?.data)
        } catch (err) {
            console.error(err);
        }
    }
 

    
  return (
    <Container>
    <Navbar/>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Empresas</h1>
      </div>
      {show ? <EditForm refresh={getUsers} show={setShow} editValue={editValues} /> : 
      <Accordion defaultActiveKey="0" alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Crear Empresa</Accordion.Header>
          <Accordion.Body>
            <Form refresh={getUsers}/>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Listado de Empresas</Accordion.Header>
          <Accordion.Body>
            <Table refresh={getUsers} axiosData={data} editUser={editUser}/>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>}
    </Container>
  );
};

export default Admin;
